import { IBudgetFormData } from '../../createAndEdit/types';
import { downloadBudgetPdf } from '../../../../modules/downloadBudgetPdf';

export interface IDetailTitleProps {
  occurrenceProtocolNumber?: string;
  occurrenceContractNumber?: string;
  budgetNumber?: string;
  budgetId?: string;
  onClose?: () => void;
  shouldShowCloseIcon?: boolean;
  onViewAttachments?: () => void;
  budgetData?: IBudgetFormData;
  redirectBack?: string;
}

const DetailTitle = (props: IDetailTitleProps) => {
  const handleDownload = async () => {
    if (!props.budgetData) {
      console.error('[DetailTitle] Dados do orçamento não disponíveis para download');
      return;
    }

    try {
      await downloadBudgetPdf(props.budgetData);
    } catch (error) {
      console.error('[DetailTitle] Erro ao fazer download do PDF:', error);
      alert('Erro ao gerar PDF do orçamento');
    }
  };

  return (
    <div className="mb-4">
      <div className="flex flex-row justify-between items-start px-6 mt-3 mb-6">
        <div className="flex flex-col">
          {props.onClose && !props.redirectBack && <button
            type="button"
            className="text-size-10 text-teal-600 underline mb-2 text-left w-fit hover:opacity-80"
            onClick={props.onClose}
          >
            Retornar para lista
          </button>}

          <div className="text-size-h4 font-bold mb-2">Orçamento</div>

          <div className="flex flex-row items-center gap-3 text-size-14 flex-wrap">
            <span className="font-bold">{props.occurrenceContractNumber ? `Contrato ${props.occurrenceContractNumber}` : ''}</span>

            <span className="text-gray-400">{props.occurrenceContractNumber &&props.occurrenceProtocolNumber ? '—' : ''}</span>
            <span className="font-bold">{props.occurrenceProtocolNumber ? `Ocorrência ${props.occurrenceProtocolNumber}` : ''}</span>
            
            <span className="text-gray-400">{props.occurrenceContractNumber && props.occurrenceProtocolNumber && props.budgetNumber ? '—' : ''}</span>
            <span className="font-bold">{props.budgetNumber ? `Orçamento ${props.budgetNumber}` : ''}</span>

            {props.onViewAttachments && <button
              type="button"
              className="flex flex-row items-center gap-2 text-teal-700 underline cursor-pointer hover:opacity-80 whitespace-nowrap"
              onClick={props.onViewAttachments}
            >
              <span>Visualizar anexos do chamados</span>
            </button>}
          </div>
        </div>

        <div className="flex flex-row items-center gap-3">
          {props.redirectBack && props.onClose && (
            <button
              type="button"
              className="text-gray-500 hover:text-gray-700 mr-2 w-10 h-10 flex items-center justify-center"
              onClick={props.onClose}
              aria-label="Fechar"
            >
              <span className="rioglyph rioglyph-remove text-size-24"></span>
            </button>
          )}
          <button
            type="button"
            className="p-2 text-teal-600 hover:bg-teal-50"
            aria-label="Download"
            onClick={handleDownload}
          >
            <img
              src="/assets/images/downloadFile.svg"
              alt="Download"
              className="w-10 h-10"
            />
          </button>
        </div>
      </div>

      <div className="border-b border-gray-200 mt-3" />
    </div>
  );
};

export default DetailTitle;
